import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María G.', 'Ana P.', 'Lucía M.', 'Sofía R.', 'Valentina C.', 'Camila S.', 'Isabella T.', 'Paula B.', 'Daniela L.', 'Fernanda O.', 'Elena V.', 'Martina D.', 'Julia A.', 'Carmen R.', 'Laura M.'];
const LOCATIONS = [{
  city: 'Buenos Aires',
  country: 'Argentina'
}, {
  city: 'Santiago',
  country: 'Chile'
}, {
  city: 'Ciudad de México',
  country: 'México'
}, {
  city: 'Lima',
  country: 'Perú'
}, {
  city: 'Bogotá',
  country: 'Colombia'
}, {
  city: 'Montevideo',
  country: 'Uruguay'
}, {
  city: 'Quito',
  country: 'Ecuador'
}, {
  city: 'La Paz',
  country: 'Bolivia'
}, {
  city: 'Asunción',
  country: 'Paraguay'
}, {
  city: 'Córdoba',
  country: 'Argentina'
}, {
  city: 'Rosario',
  country: 'Argentina'
}, {
  city: 'Medellín',
  country: 'Colombia'
}, {
  city: 'Guayaquil',
  country: 'Ecuador'
}, {
  city: 'Caracas',
  country: 'Venezuela'
}, {
  city: 'San José',
  country: 'Costa Rica'
}];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notificationData, setNotificationData] = useState({
    name: '',
    city: '',
    country: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const showNotification = () => {
      // Pick random data
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const location = LOCATIONS[Math.floor(Math.random() * LOCATIONS.length)];
      setNotificationData({
        name,
        city: location.city,
        country: location.country
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      // Schedule next notification (random between 8-15 seconds after hiding)
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1)) + 8000 + 4000;
      setTimeout(showNotification, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-1">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0,
      y: 50
    }} animate={{
      x: 0,
      opacity: 1,
      y: 0
    }} exit={{
      x: 100,
      opacity: 0,
      y: 50
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 right-4 z-50 max-w-xs w-full bg-white rounded-lg shadow-xl border-l-4 border-green-500 p-4 flex items-center gap-3" data-id="element-2">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-3">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-4" />
          </div>
          <div data-id="element-5">
            <p className="text-sm font-medium text-gray-900" data-id="element-6">
              <span className="font-bold" data-id="element-7">{notificationData.name}</span> de{' '}
              {notificationData.city}, {notificationData.country}
            </p>
            <p className="text-xs text-gray-600" data-id="element-8">
              acaba de comprar el MegaPack
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-9">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}